import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-regular-svg-icons/faSparkles';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { Features } from '../../../../../constants/features';
import { useIsSellerFeatureEnabled } from '../../../../../hooks/use-is-seller-feature-enabled';
import { useFulfillmentPlanIdContext } from '../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import {
  usePackingApplied,
  triggerCalculation,
} from '../../../../../orders/order-details/configure-shipment/fields/packing-recommend/use-packing-applied';

import messages from '../messages';
import style from './recommend-package-button.module.less';

export const RecommendPackageButton = () => {
  const intl = useIntl();
  const isPackingRecommendationEnabled = useIsSellerFeatureEnabled(Features.PackingRecommendations);
  const fulfillmentPlanId = useFulfillmentPlanIdContext() ?? '';
  const { isPackingApplied, isCalculating } = usePackingApplied(fulfillmentPlanId);

  const isDisabled = isCalculating || isPackingApplied;

  const handleClick = useCallback(() => {
    triggerCalculation(fulfillmentPlanId);
  }, [fulfillmentPlanId]);

  if (!isPackingRecommendationEnabled) {
    return null;
  }

  return (
    <Button
      ariaLabel={intl.formatMessage(messages.recommendPackage)}
      className={style['recommend-package-button']}
      disabled={isDisabled}
      onClick={handleClick}
      theme={THEME_CONSTANTS.tertiary}
    >
      <FontAwesomeIcon className={style['sparkle-icon']} icon={faSparkles} />
      {intl.formatMessage(messages.recommendPackage)}
    </Button>
  );
};
